import React, { Component } from 'react';
interface CustomerContactProps {
  customer: {
    name: string;
    email: string;
    phone: string;
  };
}
export const CustomerContact = ({
  customer
}: CustomerContactProps) => {
  const handleWhatsAppClick = (phone: string) => {
    const message = encodeURIComponent('Hello! This is regarding your order from SellUp.');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };
  return <div className="flex items-start space-x-2" data-id="element-433">
      <button onClick={() => handleWhatsAppClick(customer.phone)} className="p-1 text-green-600 hover:text-green-700 transition-colors" data-id="element-434">
        <div className="h-4 w-4" data-id="element-435" />
      </button>
      <div data-id="element-436">
        <button className="text-sm font-medium text-gray-900 hover:text-blue-600 transition-colors" data-id="element-437">
          {customer.name}
        </button>
        <div className="text-sm text-gray-500" data-id="element-438">{customer.email}</div>
      </div>
    </div>;
};